export default {
    index (sequence) {
        switch (sequence) {
            case "1":
            case "1a":
                return 0;
            case "1b":
                return 1;
            case "2":
            case "2a":
                return 2;
            case "2b":
                return 3;
        }

        return null;
    },

    units (data) {
        const units = []
        data.collection.forEach(entry => {
            units.push(entry.unit)
        });

        return units;
    },

    canceled (status) {
        if (!status) {
            return false;
        }

        return status.id === 33 || status.id === 34;
    }
}